import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-volume',
  templateUrl: './chat-volume.component.html',
  styleUrls: ['./chat-volume.component.scss'],
})
export class ChatVolumeComponent implements OnInit {
  @Input() config: any;
  constructor() {}

  ngOnInit(): void {}
}
